import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';

export default {
  extends: Form,
  data() {
    return {
      formFunctionCode: 'terminal_end_form',
      formParentCode: 'CRM20240411000000002',
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  created() {

  },

  methods: {
    formComplete() {
      this.getDetails();
    },
    setRule(item) {
      const v = item;
      return v;
    },
    async getDetails() {
      await request.post('/cps/agreeShare/getStopById', {
        stopId: this.formConfig.row.id,
      }).then((res) => {
        if (res.success) {
          this.setValue({
            ...res.result,
          });
        }
      });
    },
  },
};
